module.exports = require("lodash");


/*****************
 ** WEBPACK FOOTER
 ** external "lodash"
 ** module id = 4
 ** module chunks = 0
 **/